import { useState } from 'react';
import { Clock, Edit } from 'lucide-react';

const defaultHours = {
  monday: { open: "09:00", close: "17:00" },
  tuesday: { open: "09:00", close: "17:00" },
  wednesday: { open: "09:00", close: "17:00" },
  thursday: { open: "09:00", close: "17:00" },
  friday: { open: "09:00", close: "17:00" },
  saturday: "closed",
  sunday: "closed",
};

export default function BusinessHoursSection({ profile, updateProfile }) {
  const [showBusinessHours, setShowBusinessHours] = useState(profile?.show_business_hours ?? true);
  const [hours, setHours] = useState(profile?.business_hours || defaultHours);

  const handleSave = () => {
    updateProfile({ business_hours: hours, show_business_hours: showBusinessHours });
  };

  const toggleDay = (day) => {
    setHours(prev => ({
      ...prev,
      [day]: prev[day] === "closed" ? { open: "09:00", close: "17:00" } : "closed"
    }));
  };

  const updateTime = (day, type, value) => {
    setHours(prev => ({
      ...prev,
      [day]: { ...prev[day], [type]: value }
    }));
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-base font-bold text-gray-900 flex items-center gap-2">
          <Clock className="w-5 h-5 text-teal-600" />
          Business Hours
        </h2>
        <button onClick={handleSave} className="text-xs font-medium text-teal-600 hover:underline flex items-center gap-1">
          <Edit className="w-3.5 h-3.5" /> Save
        </button>
      </div>

      <div className="space-y-2">
        {Object.keys(hours).map(day => (
          <div key={day} className="flex items-center justify-between py-2 px-3 bg-gray-50 rounded-lg">
            <span className="font-medium text-gray-900 text-xs capitalize">{day}</span>
            {hours[day] === "closed" ? (
              <button onClick={() => toggleDay(day)} className="text-xs text-gray-500">Closed → Open</button>
            ) : (
              <div className="flex items-center gap-2">
                <input type="time" value={hours[day].open} onChange={e => updateTime(day, 'open', e.target.value)} className="text-xs" />
                <span>–</span>
                <input type="time" value={hours[day].close} onChange={e => updateTime(day, 'close', e.target.value)} className="text-xs" />
                <button onClick={() => toggleDay(day)} className="text-xs text-red-600 ml-2">Close</button>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="mt-4 flex items-center gap-2">
        <input
          type="checkbox"
          checked={showBusinessHours}
          onChange={e => setShowBusinessHours(e.target.checked)}
          className="w-4 h-4 text-teal-600 rounded"
        />
        <label className="text-xs font-medium">Show business hours on client hub</label>
      </div>
    </div>
  );
}